<template>
  <div :class="$style['adl-input']">
    <div :class="$style['label']">{{ fieldInfo.label }}</div>
    <mds-input
      ref="fieldInfotextbox"
      @input="validateUserEnteredCharCount($event)"
      v-model="fieldInfo.value"
      label=""
      :error="error"
      :error-text="fieldInfo.errorText"
    ></mds-input>
    <span :class="$style['charcount']"
      >{{ userEnterCharCount }}/{{ fieldInfo.maxValue }}</span
    >
  </div>
</template>
<script>
import MdsInput from "@mds/input";
export default {
  props: {
    fieldInfo: {
      type: Object,
    },
  },
  components: {
    MdsInput,
  },
  watch: {
    fieldInfo: {
      handler: function (val) {
        if (val.value == "" || val.value.trim() == "") {
          this.$nextTick(() => {
            this.$refs.fieldInfotextbox.$el.focus();
          });
        }
      },
    },
  },
  mounted() {
    this.setFocus();
  },
  computed: {
    error() {
      if (this.fieldInfo.error) {
        this.$refs.fieldInfotextbox.$el.focus();
      }
      return this.fieldInfo.error;
    },
    userEnterCharCount() {
      if (!this.fieldInfo.value ) {
        return 0;
      } 
       else {
        var spaceCount = this.fieldInfo.value.match(/^\s*/)[0].length;
        spaceCount = spaceCount<0?0:spaceCount;
        return this.fieldInfo.value.length - spaceCount;
      }
    },
  },

  async created() {},
  methods: {
    validateUserEnteredCharCount(evt) {
      this.fieldInfo.error = false;
      if (this.fieldInfo.value.length >= this.fieldInfo.maxValue) {
        this.fieldInfo.value = this.fieldInfo.value.substring(
          0,
          this.fieldInfo.maxValue
        );
      }
    },
    setFocus() {
      if (this.fieldInfo.value == "" || this.fieldInfo.value.trim() == "") {
        this.$refs.fieldInfotextbox.$el.focus();
      }
    },
  },
};
</script>
<style lang="scss" module>
@import "@mds/typography";
.adl-input {
  .label {
    @include mds-body-text-m();
    margin-bottom: $mds-space-1-and-a-half-x;
  }
  .charcount {
    @include mds-body-text-s();
  }
}
</style>
